<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    List Pesan Keluar
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <!--<a v-on:click="exportContact" class="btn px-15 btn-secondary text-white"
                                style="display: inline-flex; margin: 5px">-->
                            <a v-on:click="toggleModal('filter_export')" class="btn px-15 btn-secondary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-download fs-16"></i>
                                Export Pesan Keluar
                            </a>
                            <download-csv ref="exportOutgoing" :data="exportJson" name="starsender_outgoing.csv"
                                style="display: none"></download-csv>
                            <a v-on:click="toggleModal('action_resend')" class="btn px-15 btn-info text-white"
                                style="display: inline-flex; margin: 5px">
                                Resend Pesan
                            </a>
                            <a v-on:click="toggleModal('action_outgoing')" class="btn px-15 btn-danger text-white"
                                style="display: inline-flex; margin: 5px">
                                Hapus Pesan
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert alert-info" role="alert">
                <div class="alert-content">
                    <p><b>Jadwal Pengiriman Aktual</b> adalah waktu pengiriman pesan sebenarnya dari Jadwal + Delay Interval</p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <OutgoingTable />
                    </div>
                </div>
            </div>
            <modal name="action_outgoing" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <Action />
                </div>
            </modal>
            <modal name="action_resend" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <Resend />
                </div>
            </modal>
            <modal name="filter_export" :height="'auto'" :adaptive="true" :scrollable="true"  >
                <div style="margin: 50px">
                    <FilterExport />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import OutgoingTable from "@/components/tables/Outgoing.vue";
    import Action from "@/components/forms/outgoing/Action.vue";
    import Resend from "@/components/forms/outgoing/Resend.vue";
    import FilterExport from "@/components/forms/outgoing/FilterExport.vue";
    import moment from 'moment'

    export default {
        components: {
            OutgoingTable,
            Action,
            Resend,
            FilterExport
        },
        data() {
            return {
                group_dropdown: [],
                exportJson: []
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
        },
        methods: {
            async loadGroups() {
                try {
                    let response = await this.$store.dispatch('group_list_dropdown')
                    this.group_dropdown = response.data.data.groups
                } catch (err) {
                    this.$toast.error("Server error")
                }
            },
            async emptyContact() {
                if (confirm("Semua data kontak akan terhapus, Yakin ?")) {
                    try {
                        let response = await this.$store.dispatch('contact_empty')
                        this.$toast.success(response.data.message);
                        this.$root.$emit("refresh_table", true)
                    } catch (err) {
                        this.$toast.error(err.response.data.message);
                    }
                }
            },
            async exportContact() {
                try {
                    this.$toast.info("Mohon Tunggu...");

                    await this.$store.dispatch('outgoing_export')
                        .then((response) => {
                            this.exportJson = response.data.data.outgoings

                            for (let i = 0; i < this.exportJson.length; i++) {
                                this.exportJson[i].jadwal = moment.utc(this.exportJson[i].jadwal).local().format("YYYY-MM-DD HH:mm:ss")
                                this.exportJson[i].delivery_schedule = moment.utc(this.exportJson[i].delivery_schedule).local().format("YYYY-MM-DD HH:mm:ss")
                                this.exportJson[i].created_at = moment.utc(this.exportJson[i].created_at).local().format("YYYY-MM-DD HH:mm:ss")
                                this.exportJson[i].updated_at = moment.utc(this.exportJson[i].updated_at).local().format("YYYY-MM-DD HH:mm:ss")
                               
                                this.exportJson[i].device = this.exportJson[i].device ? this.exportJson[i].device.name : '-'
                                
                            }
                        })
                        .then(() => {
                            this.$refs.exportOutgoing.$el.click()
                        })
                } catch (err) {
                    this.$toast.error(err);
                }
            },
            fillVar(val) {
                return val
            },
            toggleModal(param) {
                if (this.group_dropdown.length == 0) this.loadGroups()

                this.$modal.toggle(param);
            },
        },
    };
</script>
